module.exports = __webpack_public_path__ + "static/media/popup.c4130453.jpg";